import PropTypes from 'prop-types';
import { enqueueSnackbar } from 'notistack';
import { useEffect, useState, useMemo } from 'react';
import { getRentalOrderStatus } from '../../../../../../api/rentals';
import TicketOrderSearch from './TicketOrderSearch';

OrderSearchOnly.propTypes = {
  group: PropTypes.object,
  field: PropTypes.object,
  setFieldValue: PropTypes.func,
  facilityId: PropTypes.number,
};

export default function OrderSearchOnly({ field, facilityId, setFieldValue, group })
{
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [rentalOrderStatus, setRentalOrderStatus] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const response = await getRentalOrderStatus(selectedOrder?.id);
        setRentalOrderStatus(response.data);
      } catch (error) {
        enqueueSnackbar('Failed to fetch rental order status', { variant: 'error' });
      }
    })();
  }, [selectedOrder]);

  useEffect(() => {
    setFieldValue(field, group, {
      value: selectedOrder?.orderNumber,
      htmlValue: selectedOrder ? selectedOrder?.orderType === 'Purchase' ? `<a href="/dashboard/orders/${selectedOrder.id}">${selectedOrder.label}</a>` : `<a href="/dashboard/rentals/rental-order/${selectedOrder.id}/${rentalOrderStatus}">${selectedOrder.label}</a>` : null,
      addUser: selectedOrder?.submittedBy,
      orderId: selectedOrder?.id,
      orderType: selectedOrder?.orderType,
    });      
  }, [field, selectedOrder, rentalOrderStatus]);

  return <TicketOrderSearch facilityId={facilityId} onChange={(order) => { setSelectedOrder(order);  }} />;
}